module.exports = __webpack_public_path__ + "src/img/on.1cf1a439.svg";